'use client'
import createStoreProvider from '@/components/context-factories/create-store-provider'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export interface Breadcrumb {
  id: string
  path: string
  title: string
  order: number
}

interface BreadcrumbsStore {
  breadcrumbs: Breadcrumb[]
  registerBreadcrumb: (breadcrumb: {
    id: string
    path: string
    title: string
    order: number
  }) => () => void
}

export const init = () => {
  const store = create<BreadcrumbsStore>()(
    devtools(
      (set) => ({
        breadcrumbs: [],
        registerBreadcrumb: (breadcrumb) => {
          set((state) => ({
            // Order by the explicit `order` of each crumb; fall back to path
            // comparison for crumbs that share an order (e.g. layout-based
            // crumbs that all default to 0), which keeps shallower paths first.
            breadcrumbs: [...state.breadcrumbs, breadcrumb].sort((a, b) =>
              a.order !== b.order ? a.order - b.order : a.path > b.path ? 1 : -1,
            ),
          }))

          return () => {
            set((state) => ({
              breadcrumbs: state.breadcrumbs.filter(
                (crumb) => crumb.id !== breadcrumb.id,
              ),
            }))
          }
        },
      }),
      {
        name: 'breadcrumbs-store',
      },
    ),
  )

  return store
}

const [BreadcrumbsProvider, useBreadcrumbsStore] = createStoreProvider(init)

export { BreadcrumbsProvider, useBreadcrumbsStore }
